import React, { useCallback } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useMeContext } from 'modules/me';
import { useMessage } from 'modules/intl';
import { ReactComponent as PolarisLogo } from '../icons/PolarisLogo.svg';
import CircleRepliconLogoNew from '../icons/circleRepliconLogoNew.svg';
import { goToTimesheet } from '../../../../containerApp/index';
import { AppMenuItemProps } from '../AppMenuItemProps';
import { isWithinAnotherApp } from '../../../../containerApp/index';
interface MyRepliconItemProps extends AppMenuItemProps {
  onMenuClose: () => void;
}

export const MyRepliconItem = React.forwardRef(
  (
    { classes, onMenuClose }: MyRepliconItemProps,
    ref: React.Ref<any>
  ): JSX.Element => {
    const me = useMeContext();
    const wtsUiEndpoint = me?.wtsUiEndpoint;
    const hasPolarisAcces = me?.permissions?.hasPsaAccess;

    const handleOpen = useCallback(() => {
      if (isWithinAnotherApp()) {
        goToTimesheet(wtsUiEndpoint);
      } else {
        window.location.replace(wtsUiEndpoint!);
      }

      onMenuClose();
    }, [wtsUiEndpoint, onMenuClose]);

    const altMsg = useMessage(
      hasPolarisAcces ? 'appMenu.polaris' : 'appMenu.replicon'
    );

    return (
      <MenuItem
        onClick={handleOpen}
        data-testid="go-to-timesheet-menu"
        className={classes.menuItem}
        autoFocus={true}
        ref={ref}
      >
        <ListItemIcon className={classes.icon}>
          {hasPolarisAcces ? (
            <PolarisLogo />
          ) : (
            <img
              data-testid="go-to-timesheet-menu-icon-new"
              src={CircleRepliconLogoNew}
              className={classes.repliconLogoNew}
              alt={altMsg}
            />
          )}
        </ListItemIcon>
        <ListItemText>
          <FormattedMessage
            id={hasPolarisAcces ? 'appMenu.polaris' : 'appMenu.replicon'}
          />
        </ListItemText>
      </MenuItem>
    );
  }
);

MyRepliconItem.displayName = 'MyRepliconItem';
